export const ContactFormFields = {
  formType: {
    type: "select",
    label: "Form Type",
    options: [
      { label: "Quick Quote (Name, Phone, Service, Description)", value: "quick-quote" },
      { label: "Schedule Service (Name, Phone, Email, Date/Time)", value: "schedule" },
      { label: "Emergency (Name, Phone, Address - minimal)", value: "emergency" },
      { label: "General Contact (Name, Email, Phone, Message)", value: "contact" },
    ],
    metadata: {
      source: "manual",
      description: "Preset that configures which fields are shown",
    },
  },
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Contact section heading (e.g. 'Get a Free Quote')",
      seo: true,
      key: "contact.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Inviting text encouraging contact (10-15 words)",
      seo: true,
      key: "contact.subheading",
    },
  },
  variant: {
    type: "radio",
    label: "Variant",
    options: [
      { label: "Card", value: "card" },
      { label: "Minimal", value: "minimal" },
      { label: "Highlight", value: "highlight" },
    ],
    metadata: {
      source: "manual",
      description: "Controls surface treatment and whether contact details are emphasized.",
    },
  },
  showUrgencySelector: {
    type: "radio",
    label: "Show Urgency Selector",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
    metadata: {
      source: "manual",
      description: "Show 'How soon do you need service?' selector",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Centered", value: "centered" },
      { label: "Split (Text + Form)", value: "split" },
    ],
    metadata: {
      source: "manual",
    },
  },
  submitButtonText: {
    type: "text",
    label: "Custom Submit Button Text",
    metadata: {
      source: "manual",
      description: "Leave empty to use form type default",
    },
  },
  successMessage: {
    type: "text",
    label: "Success Message",
    metadata: {
      source: "manual",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
      advanced: true,
    },
  },
} as const;
